<template>
    <div class="result">
      <span class="result__metadata">{{ dateFormatted }} - {{ result._source.startTime }} 
        <span class="result__metadataProgram">{{ result._source.program }}</span>
      </span>
      <div v-bind:class="{ 'result__shadow': this.black, 'result__shadow result__shadow--white': !this.black }"></div>

      <p v-dragscroll ref="text">
        <span v-html="htmlText" v-bind:class="{ 'text__black': this.black, 'text__white': !this.black }">
          {{ result.highlight.line[0] }}
        </span>
      </p>

      <a :href="urlTimecode" target="_blank">
        <div class="link"></div>
      </a>
      <div class="copy" @click="copyToClipboard(dateFormatted + ' – ' + result._source.program + ': ' + result.highlight.line[0])"></div>
    </div>
</template>

<script>
import { dragscroll } from 'vue-dragscroll'

export default {
  name: 'Result',
  data: function () {
    return {
      dateFormatted: '',
      urlTimecode: '',
      htmlText: this.result.highlight.line[0]
    }
  },
  directives: {
    'dragscroll': dragscroll
  },
  props: ['result', 'black'],
  mounted: function () {
    this.formatTime()
    this.formatTimecode()
  },
  methods: {
    copyToClipboard (text) {
      var dummy = document.createElement('input')
      document.body.appendChild(dummy)
      dummy.setAttribute('value', text)
      dummy.select()
      document.execCommand('copy')
      document.body.removeChild(dummy)
    },
    formatTime () {
      var tijdstipTemp = new Date(this.result._source.date)
      var thisDate = tijdstipTemp
      var dd = thisDate.getDate()
      var mm = thisDate.getMonth() + 1

      var yyyy = thisDate.getFullYear()
      if (dd < 10) {
        dd = '0' + dd
      }
      if (mm < 10) {
        mm = '0' + mm
      }
      this.dateFormatted = dd + '.' + mm + '.' + yyyy
    },
    formatTimecode () {
      var newTime = this.result._source.startTime.split(':')
      var cleanedUpSeconds = newTime[2].split('.')[0]
      var seconds = (parseInt(newTime[0]) * 3600) + (parseInt(newTime[1]) * 60) + parseInt(cleanedUpSeconds) - 5
      this.urlTimecode = this.result._source.url + '?t=' + seconds
    }
  }
}
</script>

<style scoped>
.result__metadata {
  display: block;
  color: #707070;
  font-size: 1rem;
  font-family: 'fl-mono', sans-serif;
  position: absolute;
  margin: 0 0 0 25px;
  z-index: 2;
}

.result__metadataProgram {
  color: #484848;
  text-transform: uppercase;
}

.result__shadow {
  width: 150px;
  height: 100px;
  background: rgb(0, 0, 0);
  background: linear-gradient(90deg, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0.5164040616246498) 33%, rgba(0, 0, 0, 0) 100%);
  position: absolute;
  z-index: 1;
}

.result__shadow--white {
  background: rgb(239, 239, 239) !important;
  background: linear-gradient(90deg, rgba(239, 239, 239, 1) 0%, rgba(239, 239, 239, 0.5164040616246498) 33%, rgba(239, 293, 239, 0) 100%) !important;
}

.result {
  border-bottom: 1px solid #707070;
  position: relative;
  padding-top: 30px;
}

p::-webkit-scrollbar {
  display: none;
}

.result p {
  font-family: 'Feijoa-Medium', serif;
  font-size: 38px;
  color: white;
  margin: 0 0 0 0;
  padding: 0 30px 0 30px;
  line-height: 100px;
  white-space: nowrap;
  overflow: scroll;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: -webkit-grab;
  cursor: -moz-grab;
  cursor: -o-grab;
  cursor: grab;
}

.result p:active {
  cursor: -webkit-grabbing;
  cursor: -moz-grabbing;
  cursor: -o-grabbing;
  cursor: grabbing;
}

.text__black {
  color: white !important;
}

.text__white {
  color: #383838 !important;
}

em {
  color: #FF6767;
  margin-left: 10px;
  margin-right: 10px;
  white-space: nowrap;
}

.result:hover .link, .result:hover .copy {
  display: block;
}

.link {
  display: none;
  background: #484848;
  background-image: url("../assets/icons/link.svg");
  background-repeat: no-repeat;
  background-size: 60%;
  background-position: center center;
  position: absolute;
  width: 40px;
  height: 40px;
  right: 90px;
  line-height: 100px;
  top: 0;
  bottom: 0;
  margin: auto;
  animation: opacityShift .5s linear;
}

.copy {
  display: none;
  background: #484848;
  background-image: url("../assets/icons/copy.svg");
  background-repeat: no-repeat;
  background-size: 60%;
  background-position: center center;
  position: absolute;
  width: 40px;
  height: 40px;
  right: 40px;
  line-height: 100px;
  top: 0;
  bottom: 0;
  cursor: pointer;
  margin: auto;
  animation: opacityShift .5s linear;
}

@keyframes opacityShift {
  from {opacity: 0}
}
</style>



// WEBPACK FOOTER //
// src/components/Result.vue